/**
 * Season configuration
 * 
 * Bowling season runs from September to May
 * - Sept-Dec: Use current year (e.g., Sept 2025 = 2025 season)
 * - Jan-Aug: Use previous year (e.g., Jan 2026 = 2025 season)
 */

/**
 * Calculate the current bowling season year based on the date
 * Season starts in September and ends in May
 */
export function getCurrentSeasonYear(): number {
  const now = new Date();
  const month = now.getMonth(); // 0-indexed (0 = January, 8 = September)
  const year = now.getFullYear();
  
  // September (8) through December (11) = current year's season
  // January (0) through August (7) = previous year's season
  if (month >= 8) {
    return year;
  }
  return year - 1;
}

/**
 * Get the default season year to use for queries
 * Falls back to calculated current season if no season is specified
 */
export function getDefaultSeasonYear(seasonYear?: number): number {
  return seasonYear ?? getCurrentSeasonYear();
}

/**
 * Get available season years for selection
 * Returns an array of years from the earliest available to current season
 */
export function getAvailableSeasons(earliestYear: number = 2024): number[] {
  const currentSeason = getCurrentSeasonYear();
  const seasons: number[] = [];
  
  for (let year = currentSeason; year >= earliestYear; year--) {
    seasons.push(year);
  }
  
  return seasons;
}

/**
 * Format season year for display (e.g., "2025-26 Season")
 */
export function formatSeasonDisplay(year: number): string {
  const nextYear = (year + 1) % 100;
  return `${year}-${nextYear.toString().padStart(2, '0')} Season`;
}
